import { restClient } from '../../client';
import { AppointmentRecurring } from '../../resources';


export type PatientIsAvailableForDateInput = {
  recurring: AppointmentRecurring;
  datetime: string;
  patient_id: string;
};


export type PatientIsAvailableForDateOutput = {
  available: boolean;
  error?: string;
};


export const patientIsAvailableForDate = (params: PatientIsAvailableForDateInput) => restClient.request<PatientIsAvailableForDateOutput>('/api/v1/appointment/patient/is-available-for-date', {
  method: 'POST',
  data: params
});
